import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { IPayment } from '../../interfaces/ipayment';
import { ApiService } from '../../services/jrni/api.service';
import { DatastoreService } from '../../services/datastore.service';

@Component({
  selector: 'app-abstract-verify-payment',
  templateUrl: './abstract-verify-payment.component.html',
  styleUrls: ['./abstract-verify-payment.component.scss']
})
export abstract class AbstractVerifyPaymentComponent implements OnInit {

  paymentPortalId: any = null;
  bookingId: any = null;
  paymentId: any = null;
  companyId: any = null;
  pageTitle: string = 'Loading...';

  constructor(
    public apiService: ApiService,
    public spinner: NgxSpinnerService,
    public router: Router,
    public route: ActivatedRoute,
    public dataStore: DatastoreService,
    public paymentService: IPayment
  ) { }

  ngOnInit(): void {
    this.spinner.show();
  }

  abstract verifyPayment(member: any, booking: any, purchase: any, bookingData: any, company: any): void;
  abstract cancelBooking(member: any, booking: any): Promise<void>;


}
